module.exports = __webpack_public_path__ + "img/logo58.ebebc103.png";